import React, { useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Button,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from "@mui/material";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";
import styles from "./RevenueChart.module.scss";
import { MoreVert as MoreVertIcon } from "@mui/icons-material";
import {RevenueChartType, RevenueChartProps} from "../../types/types"


const RevenueChart: React.FC<RevenueChartProps> = ({ data }) => {
  const getCurrentFYStart = () => {
    const today = new Date();
    // Financial year starts on April 1st. If today is April (month 3) or later, FY starts this calendar year.
    return today.getMonth() >= 3 ? today.getFullYear() : today.getFullYear() - 1;
  };
  const [selectedYear, setSelectedYear] = useState<number>(getCurrentFYStart());
  return (
    <Card className={styles.chartCard}>
      <CardContent>
        <Box className={styles.header}>
          <Box>
            <Typography
              variant="h6"
              className={styles.title}
              sx={{ color: "var(--mui-palette-text-primary)" }}
            >
              Spend Analysis
            </Typography>
            <Typography
              variant="body2"
              className={styles.subtitle}
              sx={{ color: "var(--mui-palette-text-secondary)" }}
            >
              Present year revenue details
            </Typography>
            <Typography
              variant="h4"
              className={styles.totalRevenue}
              sx={{ color: "var(--mui-palette-text-primary)" }}
            >
              {data.reduce((sum, month) => sum + month.expense, 0)}
            </Typography>
          </Box>
          <Box>
            {/* <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <FormControl size="small" variant="outlined" sx={{ minWidth: 160 }}>
              <InputLabel id="fy-select-label">Financial Year</InputLabel>
              <Select
                labelId="fy-select-label"
                value={selectedYear}
                label="Financial Year"
                onChange={(e) => {
                const val = Number(e.target.value);
                setSelectedYear(val);
                }}
                sx={{ background: "transparent" }}
              >
                {(() => {
                const today = new Date();
                // Financial year starts on April 1st. If today is April or later, FY starts this calendar year.
                const currentFYStart =
                  today.getMonth() >= 3 ? today.getFullYear() : today.getFullYear() - 1;
                return Array.from({ length: 5 }).map((_, i) => {
                  const start = currentFYStart - i;
                  const endShort = String(start + 1).slice(-2); // e.g. "24" for 2024-2025
                  const label = `FY ${start}-${endShort}`;
                  return (
                  <MenuItem value={start} key={start}>
                    {label}
                  </MenuItem>
                  );
                });
                })()}
              </Select>
              </FormControl>
            </Box> */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography variant="body2" sx={{ color: "var(--mui-palette-text-secondary)" }}>
                  Financial Year :
                </Typography>
                <Typography variant="subtitle1" sx={{ color: "var(--mui-palette-text-primary)", fontWeight: 600 }}>
                  {`${selectedYear}-${String(selectedYear + 1).slice(-2)}`}
                </Typography>

              </Box>
            </Box>
          </Box>
 
        </Box>

        <Box className={styles.chartWrapper}>
          <ResponsiveContainer width="100%" height={250}>
            <BarChart
              data={data}
              margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
            >
              <XAxis
                dataKey="name"
                stroke="var(--mui-palette-text-secondary)"
              />
              <YAxis stroke="var(--mui-palette-text-secondary)" />
              <Tooltip
                contentStyle={{
                  backgroundColor: "#fff",
                  border: "1px solid var(--mui-palette-divider)",
                  borderRadius: "8px",
                  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                  padding: "10px",
                }}
                labelStyle={{
                  color: "var(--mui-palette-text-primary)",
                  fontWeight: 600,
                  fontSize: "14px",
                  marginBottom: "6px",
                }}
                itemStyle={{
                  color: "var(--mui-palette-text-secondary)",
                  fontSize: "13px",
                  margin: 0,
                }}
                cursor={{ fill: "rgba(0, 112, 216, 0.1)" }}
              />
              {/* <Legend wrapperStyle={{ color: 'var(--mui-palette-text-secondary)' }} /> */}
              {/* <Bar dataKey="expense" stackId="a" fill="#0070D8" radius={[5, 5, 0, 0]} /> */}
              <Bar
                dataKey="expense"
                stackId="a"
                fill="#0070D8"
                radius={[5, 5, 0, 0]}
              />
            </BarChart>
          </ResponsiveContainer>
        </Box>
        <Box className={styles.legendContainer}>
          {/* <Box className={styles.legendItem}>
            <span className={styles.legendDot} style={{ backgroundColor: '#A767ED' }}></span>
            <Typography variant="body2" sx={{ color: 'var(--mui-palette-text-secondary)' }}>
              Pending (50%)
            </Typography>
          </Box> */}
          {/* <Box className={styles.legendItem}>
            <span className={styles.legendDot} style={{ backgroundColor: '#FFC107' }}></span>
            <Typography variant="body2" sx={{ color: 'var(--mui-palette-text-secondary)' }}>
              Income
            </Typography>
          </Box> */}
          <Box className={styles.legendItem}>
            <span
              className={styles.legendDot}
              style={{ backgroundColor: "#0070D8" }}
            ></span>
            <Typography
              variant="body2"
              sx={{ color: "var(--mui-palette-text-secondary)" }}
            >
              Scholarship Amount
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default RevenueChart;
